import React, { Component } from 'react'
import { getLfvMasterPlans, getToken, checkJapanese } from '../../../lib'
import './SubscriptionCheckoutForm.css';
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { fetchPlanDetails } from '../../../components/PlanDetails/actions'

import TextField from 'material-ui/TextField'
import './StripePaymentForm.css';
import CurrencyFormat from 'react-currency-format';
import config from '../../../config/config'
import Loader from 'react-loader'

class SubscriptionUpdateForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      accounts_allowed: props.max_accounts,
      rooms_allowed: props.max_rooms,
      errorMessage: '',
      total_price: '',
      plan_price: '',
      currentStep: 1,
      loading: false,
      paidUpgrade: false,
      accountAllowedError: false,
      roomsAllowedError: false,
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleConfirmSubmit = this.handleConfirmSubmit.bind(this)

    this._next = this._next.bind(this)
    this._prev = this._prev.bind(this)
  }

  _next() {
    let currentStep = this.state.currentStep
    currentStep = currentStep >= 2? 2: currentStep + 1
    this.setState({
      currentStep: currentStep
    })
  }
    
  _prev() {
    let currentStep = this.state.currentStep
    currentStep = currentStep <= 1? 1: currentStep - 1
    this.setState({
      currentStep: currentStep
    })
  }

  async componentDidMount() {
    const token = getToken()
    this.props.fetchPlanDetails(token);
    const res = await getLfvMasterPlans();
    if (res.status && res.status === 'success') {
      let plan_price = res.data.plans.filter(plan => plan && plan.name === 'plan_price')[0].price
      this.setState({
        plan_price: plan_price,
        total_price: (5 + (this.state.accounts_allowed * this.state.rooms_allowed - 1)) * plan_price
      })
    }
  }

  handleChange = (e, purpose) => {
    let total_price = this.state.total_price;
    if (purpose === 'accounts_allowed') {
      if(e.target.value.length > 0){
        this.setState({accounts_allowed: e.target.value,  accountAllowedError: false})
        total_price = (5 + (e.target.value * this.state.rooms_allowed - 1)) * this.state.plan_price;
      }
      else
        this.setState({ accounts_allowed: e.target.value, accountAllowedError: true })
    } else if (purpose === 'rooms_allowed') {
      if(e.target.value.length > 0)
      {
        this.setState({rooms_allowed: e.target.value,  roomsAllowedError: false})
        total_price = (5 + (this.state.accounts_allowed * e.target.value - 1)) * this.state.plan_price;
      }
      else
        this.setState({ rooms_allowed: e.target.value, roomsAllowedError: true })
    }
    this.setState({total_price})
  }

  handleConfirmSubmit = async (evt) => {
    evt.preventDefault();
    this.setState({ loading: true })
    try {
      const { accounts_allowed, rooms_allowed } = this.state;
      const payload = {
        accounts_allowed: accounts_allowed,
        rooms_allowed: rooms_allowed
      }
      let response = await fetch(`${config.URI}/api/v1/update_plan`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Authenticity-Token': getToken()
        },
        body: JSON.stringify(payload)
      })
      let res = await response.json()
      if (res.errors && Object.keys(res.errors).length >= 1) {
        this.setState({ loading: false })
        let error_message = res.errors.payment;
        if (checkJapanese()) {
          error_message = '何かが間違っていました。もう一度やり直してください' ;
        }

        if (res.errors.payment === "rooms_error") {
          error_message = <FormattedMessage id="CreateDomainLabel.downgradeMesage"/>
        }

        this.setState({errorMessage: error_message})
        return this.setState({ currentStep: 1 })
      }
      
      return this.setState({paidUpgrade: true})

    } catch (error) {
      console.error(error)
    }
    this.setState({ loading: false })
  }

  handleSubmit = e => {
    e.preventDefault();

    if (this.props.max_rooms == this.state.rooms_allowed && this.props.max_accounts == this.state.accounts_allowed) {
      this.setState({errorMessage: <FormattedMessage id="CreateDomainLabel.planChangesRequired"/>})
    } else if (this.props.created_rooms_count > this.state.rooms_allowed) {
      this.setState({errorMessage: <FormattedMessage id="CreateDomainLabel.downgradeMesage"/>})
    } else if (this.props.created_users_count > this.state.accounts_allowed) {
      this.setState({errorMessage: <FormattedMessage id="CreateDomainLabel.downgradeMesage"/>})
    } else {
      this.setState({errorMessage: ''})
      this._next();
    }
  }

  closeModal = () => {
    window.location.search = ''
  }

  render() {
    return (
      <div className="CardDemo">
          <div className="checkbox-frame">
            {this.state.paidUpgrade ?
              <div>
                <h2 className="text-center"><FormattedMessage id="CreateDomainLabel.completed"/></h2>
                <p className="text-center"><FormattedMessage id="CreateDomainLabel.sentInformation"/></p>
                <button
                  type="button"
                  className="back-btn"
                  onClick={this.closeModal} >
                  X <FormattedMessage id="previewModal.close"/>
                </button>
              </div>
            :
              <div>
                {this.state.loading && <Loader loaded={false} lines={13} length={20} width={10} radius={30}
                  corners={1} rotate={0} direction={1} color="#000" speed={1}
                  trail={60} shadow={false} hwaccel={false} className="spinner"
                  zIndex={2e9} top="50%" left="50%" scale={1.00}
                  loadedClassName="loadedContent" />}
                {this.state.currentStep == 1 &&
                  <form onSubmit={this.handleSubmit} className="stripe-payment-form">
                    <h2 className="text-center"><FormattedMessage id="plan.changePlan" /></h2>
                    {this.state.errorMessage && <div className="error-msg" role="alert">
                      {this.state.errorMessage}
                    </div>}
                    <div className="box-shadow form-box">
                      <div className="box-header">
                        <span className="required">※<FormattedMessage id="CreateDomainLabel.required" /></span> <FormattedMessage id="CreateDomainLabel.desiredPlan" />
                      </div>
                      <div className="box-body">
                        <div className="input-row">
                          <div>
                            <label>
                              <FormattedMessage id="CreateDomainLabel.desiredAccounts" />
                            </label>
                          </div>
                          <div className="space-right">
                            <div className="width120">
                              <TextField
                                type="number"
                                value={this.state.accounts_allowed}
                                onChange={e => this.handleChange(e, 'accounts_allowed')}
                                fullWidth
                                required
                                max="50"
                                min="1"
                                step="1"
                                errorText={this.state.accountAllowedError ? <FormattedMessage id='login.requiredField' /> : ''}
                              />
                            </div>
                            <span>ID</span>
                          </div>
                        </div>
                        <div className="input-row">
                          <div>
                            <label>
                              <FormattedMessage id="CreateDomainLabel.desiredRooms" />
                            </label>
                          </div>
                          <div className="space-right">
                            <div className="width120">
                              <TextField
                                type="number"
                                value={this.state.rooms_allowed}
                                onChange={e => this.handleChange(e, 'rooms_allowed')}
                                fullWidth
                                required
                                min="1"
                                max="50"
                                step="1"
                                errorText={this.state.roomsAllowedError ? <FormattedMessage id='login.requiredField' /> : ''}
                              />
                            </div>
                            <span><FormattedMessage id="CreateDomainLabel.room" /></span>
                          </div>
                        </div>
                        <div className="price-box">
                          <p><FormattedMessage id="CreateDomainLabel.monthlyCost" />: <span className="price-value"> <CurrencyFormat value={this.state.total_price} displayType={'text'} thousandSeparator={true} prefix={'￥'} /> <FormattedMessage id="CreateDomainLabel.taxIncluded" /></span></p>
                          <p>※<FormattedMessage id="CreateDomainLabel.priceListDetails" /> <a href="https://www.freshvoice.net/lite/" target="_blank"><span className="price-text"><FormattedMessage id="CreateDomainLabel.here" /></span></a> <FormattedMessage id="CreateDomainLabel.referTo" /></p>
                        </div>
                      </div>
                    </div>
                    <button disabled = {this.state.roomsAllowedError || this.state.accountAllowedError ? true : false}type="submit" className="btn"><FormattedMessage id="CreateDomainLabel.proceedToConfirm" /> </button>
                  </form>
                }
                {this.state.currentStep == 2 &&
                  <form onSubmit={this.handleConfirmSubmit} className="confirmForm">
                    <h2 className="text-center"><FormattedMessage id="CreateDomainLabel.inputConfirmation"/></h2>
                    <p className="text-center"><FormattedMessage id="CreateDomainLabel.checkInformation"/></p>
                    <div className="box-shadow form-box">
                      <div className="box-header">
                        <FormattedMessage id="plan.plan"/>
                      </div>
                      <div className="box-body">
                        <div className="input-row">
                          <div>
                            <label>
                              <FormattedMessage id="CreateDomainLabel.idNumbers"/>
                            </label>
                          </div>
                          <div className="space-right">
                            <div className="width120">
                              {this.state.accounts_allowed} ID
                            </div>
                          </div>
                        </div>
                        <div className="input-row">
                          <div>
                            <label>
                              <FormattedMessage id="CreateDomainLabel.roomNumbers"/>
                            </label>
                          </div>
                          <div className="space-right">
                            <div className="width120">
                              {this.state.rooms_allowed} <FormattedMessage id="CreateDomainLabel.room"/>
                            </div>
                          </div>
                        </div>
                        <div className="input-row confirmPrice">
                          <div>
                            <label>
                            <FormattedMessage id="CreateDomainLabel.price"/>
                            </label>
                          </div>
                          <div className="space-right">
                            <div className="">
                              <p><FormattedMessage id="CreateDomainLabel.monthlyCost"/>: <span className="price-value"> <CurrencyFormat value={this.state.total_price} displayType={'text'} thousandSeparator={true} prefix={'￥'} /> <FormattedMessage id="CreateDomainLabel.taxIncluded"/></span></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button type="button" className="back-btn confirm-btns" onClick={this._prev}> <FormattedMessage id="CreateDomainLabel.back"/> </button>
                    <button type="submit" className="btn confirm-btns"><FormattedMessage id="CreateDomainLabel.confirm"/></button>
                  </form>
                }
              </div>
            }
          </div>          
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
  }
}
const mapDispatchToProps = dispatch => ({
  fetchPlanDetails: (token) => dispatch(fetchPlanDetails(token))
})
export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionUpdateForm)



// WEBPACK FOOTER //
// src/routes/ManagePlans/Plans/SubscriptionUpdateForm.js